import React, {useState, useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {useNavigate} from 'react-router-dom';
import {Header, Titulo, ContenedorHeader,ContenedorBotones} from './elementos/Header';
import {Formulario, ContenedorBoton, ContenedorLogo} from './elementos/ElementosInicioSesion';
import {Lista, ElementoLista, Descripcion, Fecha, BotonAccion, Input, ContenedorFiltro, BotonFiltro, ContenedorSubtitulo, Subtitulo,
  Boton, ContenedorFiltroDoble, ContenedorFiltroMoviles, BotonOpciones,ContenedorSubtituloPequeño,FormularioApp,ContenedorSubtituloPequeño2,ContenedorDoble
} from './elementos/ElementosApp';
import BotonCerrarSesion from "./elementos/BotonCerrarSesion";
import { useAuth } from './contextos/AuthContext';

import Swal from 'sweetalert2';
import {db} from './firebase/firebaseConfig';
import { ref, orderByChild, equalTo,query, onValue, push, set, limitToFirst} from "firebase/database";
import {auth} from './firebase/firebaseConfig';
import {signOut} from 'firebase/auth';
import useObtenerAdmin from './hooks/useObtenerAdmin'


const App = () => {
	const navigate = useNavigate();
  const {usuario} = useAuth();
  const [TipoUsuario, cambiarTipoUsuario] = useState([]);
  const uid = usuario.uid
  const UsarioLog = useObtenerAdmin({uid});
  const [Escliente, cambiarEscliente] = useState(true);

useEffect (()=>{
  console.log(UsarioLog)    
  if (UsarioLog.cliente === 'undefined' || UsarioLog.cliente === 'Sin Permisos' || UsarioLog.cliente === null)
  {cambiarTipoUsuario('salir')}
  else
  {    
    if (UsarioLog.cliente === 'R.T ESTRELLA' || UsarioLog.cliente === 'R.T Estrella')
      {cambiarTipoUsuario('admin')}
    else
      {
        if (Number(UsarioLog.numero) > 0)
        {{cambiarTipoUsuario('conductor')}
      }
        else{
          {cambiarTipoUsuario('cliente')}
      }
        
      }
  }
},[UsarioLog]);


useEffect (()=>{    

  //console.log(UsarioLog.cliente)
  if (UsarioLog.cliente === 'undefined' || UsarioLog.cliente === 'Sin Permisos' || UsarioLog.cliente === null)
  {cambiarTipoUsuario('salir')
  Swal.fire({
    title: 'Usuario sin acceso',
    text: 'Usted no posee acceso al sistema de administración',
    icon: 'warning',
    timer:2000
    })
    try {
			signOut(auth);
			navigate('/iniciar-sesion');
		} catch(error){
			console.log(error);
		}
}
  else
  {    
    if (UsarioLog.cliente === 'R.T ESTRELLA' || UsarioLog.cliente === 'R.T Estrella')
      {cambiarTipoUsuario('admin')
      //console.log('entra admin')
      cambiarEscliente(false)}
    
    else
      {
        if (Number(UsarioLog.numero) > 0)
        {{cambiarTipoUsuario('conductor')}
        //console.log('entra Conductor')
      }
        else{
          {cambiarTipoUsuario('cliente')}
          //console.log('entra cliente')
        }
    }
      //cambiarEscliente(true)
  }
},[UsarioLog]);

console.log(TipoUsuario)
	return (
		<>
			<Helmet>
				<title>Clientes RTE</title>
			</Helmet>

			<Header>
				<ContenedorHeader>
					
          
        <Titulo>Central Radio Taxi Estrella</Titulo>

    <BotonCerrarSesion />
				</ContenedorHeader>


			</Header>

			<FormularioApp >
      <ContenedorLogo style={{ 
            backgroundImage: `url("https://www.radiotaxiestrella.cl/images/lo2.jpg")` ,
	          backgroundPosition: 'center',
	          backgroundRepeat: 'no-repeat',
	          width:'300px' 
           }}>
    </ContenedorLogo>
              <ContenedorSubtituloPequeño2>Usuario</ContenedorSubtituloPequeño2>
              <ContenedorSubtituloPequeño>Bienvenido,&nbsp; <Descripcion>{UsarioLog.nombre}</Descripcion></ContenedorSubtituloPequeño> 
              {!(UsarioLog.hasOwnProperty("numero"))
                    ? <ContenedorSubtituloPequeño>Administrador de <Descripcion>{UsarioLog.cliente}</Descripcion></ContenedorSubtituloPequeño>
                    : <ContenedorSubtituloPequeño>Conductor de Movil<Descripcion>{UsarioLog.numero}</Descripcion></ContenedorSubtituloPequeño>
                    }
              
              <ContenedorSubtituloPequeño2>Gestion de Traslados</ContenedorSubtituloPequeño2>
              <ContenedorDoble><BotonOpciones to="/listar-activos">En Curso</BotonOpciones><BotonOpciones to="/listar-terminados">Busqueda</BotonOpciones></ContenedorDoble>
              <BotonOpciones to="/crear-viaje">Crear</BotonOpciones>
              <ContenedorSubtituloPequeño2>Administracion de Cuentas</ContenedorSubtituloPequeño2>
              <div hidden={Escliente}><ContenedorDoble>
              <div hidden={Escliente}><BotonOpciones to="/clientes">Clientes</BotonOpciones></div>
              <div hidden={Escliente}><BotonOpciones to="/conductores">Conductores</BotonOpciones></div>
              </ContenedorDoble></div>
              <ContenedorDoble>
              <BotonOpciones to="/pasajeros">Pasajeros</BotonOpciones>
              <BotonOpciones to="/mapa">Mapa de Ubicacion</BotonOpciones>
              </ContenedorDoble>
              <div hidden={Escliente}><ContenedorSubtituloPequeño2>Aplicación Conductor</ContenedorSubtituloPequeño2></div>
              <div hidden={Escliente}><ContenedorDoble> <BotonOpciones to="https://radiotaxiestrella.cl/app/cl.appradiotaxiestrella.conductor.37.apk">Descargar para Movil</BotonOpciones><BotonOpciones to="https://df3kiwcb5a9b0.cloudfront.net/">Ver en Web</BotonOpciones> </ContenedorDoble></div>
              <div hidden={Escliente}><ContenedorSubtituloPequeño2>Aplicación Pasajero</ContenedorSubtituloPequeño2></div>
              <div hidden={Escliente}><ContenedorDoble> <BotonOpciones to="https://radiotaxiestrella.cl/app/cl.appradiotaxiestrella.pasajero.12.apk">Descargar para Movil</BotonOpciones><BotonOpciones to="https://pasajero.radiotaxiestrella.cl/">Ver en Web</BotonOpciones> </ContenedorDoble></div>
 			</FormularioApp>


		</>
	);
}
 
 
export default App;
